import React from "react";
import "./about-main.css";
import companyLogo from "../assets/images/fintechsmart_Logo.png";
import { BrandLogo } from "./FintechSmartSolutions";
import aboutImage from "../assets/images/about-banner.jpg";

function AboutUs() {
  return (
    <section className="about-hero">
      <div className="about-container">
        {/* Left content */}
        <div className="about-left">
          <BrandLogo src={companyLogo} alt="Fintech Smart Solutions Logo" className="logo" />
          <h1 className="gradient-heading">
            About <span>Fundswalle</span>
          </h1>
          <p className="about-text">
            Fundswalle is redefining digital lending with innovative solutions that 
            are fast, secure, and designed to help you achieve your financial goals. 
            Experience seamless, smart, and reliable financial services.
          </p>
          <div className="about-cta">
            <a href="#" className="btn-primary">Get Started</a>
            <a href="#" className="btn-outline">Learn More</a>
          </div>
        </div>

        {/* Right illustration */}
        <div className="about-right">
          <div className="image-wrapper">
            <img src={aboutImage} alt="About Illustration" className="animated-image"/>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
